import { createReducer } from '../lib/createReducer';

const initialState = {
  operationsMetrics: [],
  companiesWithWorkflows: [],
  apiCalls: [],
  workflowOperations: []
};

export default createReducer(initialState, {
  GET_OPERATION_METRICS_SUCCESS: (state, payload) => ({
    ...state,
    operationsMetrics: payload?.data || []
  }),
  GET_COMPANIES_WITH_WORKFLOWS_SUCCESS: (state, payload) => ({
    ...state,
    companiesWithWorkflows: payload?.data || []
  }),
  GET_API_CALLS_SUCCESS: (state, payload) => ({
    ...state,
    apiCalls: payload?.data || []
  }),
  GET_WORKFLOW_OPERATIONS_SUCCESS: (state, payload) => ({
    ...state,
    workflowOperations: payload?.data || []
  })
});
